import * as React from 'react'
import { Select } from '../../../../components/UI/Select'
import { Styled } from './styled'
import { NewStyled as ParentStyled } from '../../styled'
import { useSignupProductOptions } from '../../hooks/useSignupProductOptions'
import { Button } from '../../../../components/UI/Button'
import { useRegistrationContext } from '../../context/registration'
import { useTranslation } from '../../../../lib/context/i18n'
import { isServer } from '../../../../lib/utils'
import { productCategoryMap } from '../../../../lib/constants'
import { snakeCase } from 'lodash'
import { useSignupContext } from '../../context/signup'
import CustomLink from '../../../../components/CustomLink'

export const ProductSelection = () => {
  const {
    productName,
    setProductName,
    productVariant,
    setProductVariant,
    operatingSystem,
    setOperatingSystem,
    setStep,
  } = useSignupContext()
  const t = useTranslation()
  const { goto, blok } = useRegistrationContext()
  const { isAuthenticated, setIsAuthenticated } = useRegistrationContext()
  const { operatingSystemOptions, productOptions, productVariantOptions } = useSignupProductOptions({
    operatingSystem: operatingSystem,
    productShortCode: productName,
    productVariant: productVariant,
  })

  const filteredOperationSystemOptions = operatingSystemOptions.filter(option => option.platform !== '')

  const isDisabled = !productName || !productVariant || (filteredOperationSystemOptions.length > 0 && !operatingSystem)
  const productSelection = operatingSystemOptions.length === 1 ? operatingSystemOptions[0].code : operatingSystem

  // const infoBannerVisible = React.useMemo(() => {
  //   return productName !== '_PDFSDK' && productName !== ''
  // }, [productName])


  React.useEffect(() => {
    setOperatingSystem('')
  }, [productVariant])
  const logout = React.useCallback(() => {
    setIsAuthenticated(false)
    if (window && !isServer()) {
      window.localStorage.removeItem('token')
    }
    goto('/')
  }, [setIsAuthenticated, goto])
  return (
    <>
      <ParentStyled.CardHeader>
        <ParentStyled.CardTitle as="h2">{blok?.productSelectionTitle}</ParentStyled.CardTitle>
        {blok?.productSelectionSubline && (
          <ParentStyled.CardSubline>{blok.productSelectionSubline}</ParentStyled.CardSubline>
        )}
      </ParentStyled.CardHeader>
      {/* todo commented for now  */}
      {/* <Styled.InfoBanner visible={infoBannerVisible}>
        <p>Did you know that our <span>Pdf Tools SDK</span> offers the same features and more?</p>
        <Button
          iconRight="arrow-right"
          as={CustomLink}
          to={"/products/conversion/pdf-tools-sdk"}
          $variant="tertiary"
          $size="small"
          $inverted
        >
          See Pdf Tools SDK
        </Button>

      </Styled.InfoBanner> */}
      <Styled.Wrapper>
        <Select
          label={t('PRODUCT')}
          onChange={e => setProductName(e.currentTarget.value)}
          value={productName}
          variant="dark"
        >
          {productOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.name}
            </option>
          ))}
        </Select>
        <Select
          label={t('PRODUCT_VARIANT')}
          onChange={e => setProductVariant(e.currentTarget.value)}
          variant="dark"
          value={productVariant}
          disabled={productVariantOptions.length === 0}
        >
          {productVariantOptions.map(option => (
            <option key={option.variant} value={option.variant}>
              {option.variant}
            </option>
          ))}
        </Select>
        <Select
          label={t('OPERATION_SYSTEM')}
          onChange={e => setOperatingSystem(e.currentTarget.value)}
          variant="dark"
          value={operatingSystem}
          disabled={filteredOperationSystemOptions.length === 0}
        >
          {filteredOperationSystemOptions.map(option => (
            <option key={option.code} value={option.code}>
              {option.platform}
            </option>
          ))}
        </Select>
      </Styled.Wrapper>
      <ParentStyled.CardFooter>
        <Button iconRight="arrow-right" $variant="primary" $inverted disabled={isDisabled} onClick={() => setStep(1)}>
          {isAuthenticated ? t('NEXT') : t('NEXT_STEP')}
        </Button>
        {isAuthenticated ? (
          <Button onClick={logout} $variant="tertiary" $inverted iconRight="logout">
            {t('LOGOUT')}
          </Button>
        ) : (
          <Button
            iconRight="login"
            $variant="tertiary"
            $inverted
            onClick={() => goto('/login', { selection: productSelection, productName })}
            disabled={!productSelection}
          >
            {t('ALREADY_HAVE_EXISTING_ACCOUNT')}
          </Button>
        )}
      </ParentStyled.CardFooter>
    </>
  )
}
